import React, { FC } from 'react'
import Image from 'next/image'
import { Container, Box, Stack, SimpleGrid, Text, useDisclosure } from '@chakra-ui/react'
import { H2Title, ListWithIcons } from 'src/uikit'
import GenericModalContainer from 'src/containers/GenericModalContainer'
import QuadrilateroVerde from 'public/images/quadrilatero_verde'

import { ArrowForwardIcon } from '@chakra-ui/icons'

interface Props {
  image: string
  itemsTitle: string
  items: Array<string>
  descriptionTitle: string
  description: string
  hrefTitle: string
  content: { title: string, text: string }
}

const HowNltWorksSection: FC<Props> = ({
  image,
  itemsTitle,
  items,
  description,
  descriptionTitle,
  hrefTitle,
  content,
}) => {
  const { isOpen, onOpen, onClose } = useDisclosure()

  return <Box bg="baseWhite">
    <Container as={Stack} maxW="7xl" py="xxl6" pl="17rem">
      <SimpleGrid
        columns={{ base: 2, sm: 1, md: 2 }}
        spacing="l"
        textAlign="center"
      >
        <Stack align="center" pos="relative">
          <Box height="25.625rem" width="37.063rem">
            <Image
              className="rounded"
              src={image}
              alt={descriptionTitle}
              width="593"
              height="358"
              objectFit="contain"
              loading="lazy"
              decoding="async"
            />
          </Box>
          <Box
            w="23.25rem"
            h="21.625rem"
            pos="absolute"
            left="-19rem"
            top="2rem"
          >
            <Box position="absolute">
              <QuadrilateroVerde />
            </Box>
            <Box
              position="absolute"
              padding="xl"
              paddingRight="xxl5"
            >
              <H2Title mr="4" mb="7" fontSize="1.5rem" lineHeight="1.938rem">{descriptionTitle}</H2Title>
              <Text
                fontFamily="Montserrat-Medium"
                fontSize="1rem"
                lineHeight="1.425rem"
                textAlign="left"
                color="baseWhite"
                mt=".75rem"
              >
                {description}
              </Text>
            </Box>
          </Box>
        </Stack>

        <Stack textAlign="left" ml="xxl3">
          <H2Title color="baseDark">{itemsTitle}</H2Title>
          <ListWithIcons items={items} color="baseDark" fontFamily="Montserrat-SemiBold" />
          <Text
            fontFamily="Montserrat-Medium"
            color="baseDark"
            _hover={{
              color: 'primaryGreen.600',
              cursor: 'pointer'
            }}
            onClick={onOpen}
          >
            {hrefTitle} <ArrowForwardIcon />
          </Text>
          <GenericModalContainer isOpen={isOpen} onClose={onClose} title={content.title}>
            {content.text}
          </GenericModalContainer>
        </Stack>
      </SimpleGrid>
    </Container>
  </Box>
}

export default HowNltWorksSection
